var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "sidebar" }, [
      _vm._m(0),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.login($event)
            }
          }
        },
        [
          _c("Alert", { attrs: { message: _vm.message } }),
          _c("div", { staticClass: "field" }, [
            _c("label", [_vm._v("Email")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: {
                required: "",
                type: "text",
                name: "email",
                "data-cy": "email"
              },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", [_vm._v("Password")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              attrs: {
                required: "",
                type: "password",
                name: "password",
                "data-cy": "password"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            })
          ]),
          _c(
            "button",
            {
              class: [
                _vm.loading === 1 ? "load" : _vm.loading === 2 ? "ok" : null
              ],
              attrs: { name: "", type: "submit" }
            },
            [_vm._v("Login")]
          ),
          _c(
            "div",
            {
              staticClass: "link",
              on: {
                click: function($event) {
                  return _vm.navigateTo("/forgot-password")
                }
              }
            },
            [_vm._v("Forgot password →")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "footer" })
    ]),
    _c("div", {
      staticClass: "image bg-local",
      style: { "background-image": "url('" + _vm.image + "')" }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("img", {
        staticClass: "h-20 mr-4",
        attrs: { src: require("@/assets/img/logo.svg") }
      }),
      _c("div", { staticClass: "brand" }, [
        _c("div", { staticClass: "title" }, [_vm._v("PandaVue")]),
        _c("div", { staticClass: "subtitle" }, [_vm._v("WWF-Australia")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }